import { MathX } from "../../math/MathX";

export enum MusicKey
{
  c,
  [ "c#" ],
  d,
  [ "d#" ],
  e,
  f,
  [ "f#" ],
  g,
  [ "g#" ],
  a,
  [ "a#" ],
  b
}

export class MusicKeys 
{
  static getOffset( key:MusicKey ):number
  {
    switch ( key )
    {   
      case MusicKey.c:       return 0; 
      case MusicKey[ "c#" ]: return 1; 
      case MusicKey.d:       return 2; 
      case MusicKey[ "d#" ]: return 3; 
      case MusicKey.e:       return 4; 
      case MusicKey.f:       return 5; 
      case MusicKey[ "f#" ]: return 6; 
      case MusicKey.g:       return 7; 
      case MusicKey[ "g#" ]: return 8; 
      case MusicKey.a:       return 9; 
      case MusicKey[ "a#" ]: return 10; 
      case MusicKey.b:       return 11;
    }
    
    return null;
  }

  static fromOffset( offset:number ):MusicKey
  {
    offset = MathX.repeat( offset, 12 );

    switch ( offset )
    {   
      case 0: return MusicKey.c;
      case 1: return MusicKey[ "c#" ];
      case 2: return MusicKey.d;
      case 3: return MusicKey[ "d#" ];
      case 4: return MusicKey.e;
      case 5: return MusicKey.f;
      case 6: return MusicKey[ "f#" ];
      case 7: return MusicKey.g;
      case 8: return MusicKey[ "g#" ];
      case 9: return MusicKey.a;
      case 10: return MusicKey[ "a#" ];
      case 11: return MusicKey.b;
    }
    
    return null;
  }
}